import React from 'react';

export const TooltipContext = React.createContext({
  showFunctionTooltip: false,
  toggleFunctionTooltip: (value: boolean) => {}
});
